import React from 'react';
import { numberUtils } from '@indico-data/utils';
import classNames from 'classnames';
import { BorderSelect, Button, Icon, Flag } from 'Permafrost/index';
import { StyledHeader } from './Header.styles';
export const Header = (props) => {
    const { title, headerComponent, sortBy, aggregateCount, flagText, hasFlagMessage } = props;
    return (React.createElement(StyledHeader, { className: classNames({ 'flag-message': hasFlagMessage }) },
        React.createElement("div", { className: "title-container" },
            React.createElement("h2", { className: "title" }, title),
            React.createElement("span", { className: "count" }, aggregateCount ? numberUtils.numberWithCommas(aggregateCount) : null),
            flagText ? React.createElement(Flag, { className: "Header__flag", text: flagText }) : null),
        React.createElement("div", { className: "controls-container" },
            headerComponent ? React.createElement("div", { className: "header-component" }, headerComponent) : null,
            sortBy ? (React.createElement("div", { className: "sort-by" },
                React.createElement(BorderSelect, Object.assign({ label: "Sort By", value: sortBy.value, options: sortBy.items, onChange: (e) => {
                        sortBy.onSort(e.target.value);
                    }, horizontal: true }, props.selectProps)),
                React.createElement(Button, { "data-cy": "dataset--sort-by-btn", onClick: () => sortBy.updateDescending(), variant: "no-style", className: "button-sort-direction" },
                    React.createElement(Icon, { name: "fa-arrow-down", ariaLabel: "descending", size: [16], style: { transform: sortBy.descending ? '' : 'rotate(180deg)' } })))) : null)));
};
//# sourceMappingURL=Header.js.map